var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('confirmDlg',{ref:"confirm"}),_c('messageDlg',{ref:"message"}),_c('loaderDlg',{ref:"loader"}),_c('v-content',[_c('router-view')],1),_c('RwFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }